module.exports = __webpack_public_path__ + "static/media/115-belize.e36ae432.svg";